import { formatTime } from '../utils/FormateDateTime';
import { sequenceTableTemplate, statusTemplate } from '../utils/squenceTableNo';
export const usersTableColumnsData = t => [
  {
    body: sequenceTableTemplate,
    header: t('No'),
    style: { width: '3rem' }
  },
  {
    field: 'user.employee_id',
    header: t('EmployeeId')
  },
  {
    field: 'name',
    header: t('UserName')
  },
  {
    field: 'user.email',
    header: t('Email')
  },
  {
    field: 'user.document_id',
    header: t('DocumentNo')
  },
  {
    field: 'user.mobile_number',
    header: t('ContactNo')
  },
  {
    field: 'role',
    header: t('Role')
  },
  {
    header: t('department'),
    body: (row) => row?.practitioner?.department?.name_en || "-"
  },
  {
    field: 'user.nationality',
    header: t('Nationality')
  },
  {
    body: statusTemplate,
    header: t('Is Active')
  },
  {
    field: 'in_patient',
    header: t('In Patient')
  }
];

export const userRolesOptionsFormat = (data = []) => {
  if (!data) return [];
  return data?.map(data => {
    return {
      label: data?.name_en,
      value: data?.id
    };
  });
};

export const userRolesNamesOptionsFormat = (data = []) => {
  if (!data) return [];
  return data?.map(data => {
    return {
      label: data?.name_en,
      value: data?.name_en
    };
  });
};

export const pracitionerSpecialityOptions = (data = []) => {
  return data?.map(data => {
    return {
      label: data?.name_en,
      value: data?.id,
      data: data
    };
  });
};

export const practionerDepartmentOptions = (data = []) => {
  console.log(data, "adsfda");

  return data?.map(data => {
    return {
      label: data?.name_en,
      value: data?.id || data?._id,
      branch_id: data?.erp_branch_id,
      data: data
    };
  });
};

export const formatedNurseOptions = (data = []) => {
  return data?.map(data => {
    return {
      label: data?.name,
      value: data?.nurse_id,
      data: data
    };
  });
};

export const shiftsDataOptionsFormat = (data = []) => {
  return data?.map(data => {
    return {
      label: data?.title + ' ( ' + data?.timing?.start_time + ' To ' + data?.timing?.end_time + ' )',
      value: data,
      data: data
    };
  });
};
export const practitionerShiftsDataOptionsFormat = (data = []) => {
  return data?.map(data => {
    return {
      label: data?.title + ' ( ' + data?.timing?.start_time + ' To ' + data?.timing?.end_time + ' )',
      value: data?.id,
      data: data
    };
  });
};

export const statusOptions = [
  { label: 'Active', value: 'active' },
  { label: 'Inactive', value: 'inactive' }
];

export const roleOptions = roles =>
  roles
    ?.filter(role => role?.name_en != 'Admin' && role?.name_en != 'Patient')
    ?.map(role => ({
      label: role.name_en,
      value: role.name_en
    })) || [];

export const userDetailsList = (userData, t) => {
  return [
    {
      label: t('EmployeeId'),
      text: userData?.user?.employee_id || '--'
    },
    {
      label: t('UserName'),
      text: userData?.user?.full_name || '--'
    },
    {
      label: t('Email'),
      text: userData?.user?.email || '--'
    },
    {
      label: t('Role'),
      text: userData?.role || '--'
    },
    {
      label: t('ContactNo'),
      text: userData?.user?.mobile_number || '--'
    },
    {
      label: t('DocumentNo'),
      text: userData?.user?.document_id || '--'
    },
    {
      label: t('Nationality'),
      text: userData?.user?.nationality || '--'
    },
    {
      label: t('Status'),
      text: userData?.status || '--'
    }
  ];
};
